<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">Enter your email and password to sign in</p>
                </div>
                <div class="card-body">
                  <form role="form">
                    <div class="mb-3">
                      <input type="email" class="form-control" placeholder="Email"  v-model="email" size="lg" />
                    </div>
                    <div class="mb-3"> 
                      <input type="password" class="form-control" placeholder="Password" v-model="password" size="lg" />
                    </div>
                    <div class="text-center">
                      <input type="submit" class="form-control" value="Sign In" @click.prevent="Todashboard">
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative  bg-logo h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
              >
                <img src="./../../public/img/logo2.png" alt=""> 
  
                <!-- <h4
                  class="mt-5 font-weight-bolder position-relative text-white"
                >WOMI</h4> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!-- <p v-for="item in list" :key="item.id">
  {{item.id}}
  </p> -->
  

</template>

<script>
import axios from "axios";
import APIs from "@/../config";

const body = document.getElementsByTagName("body")[0];
export default {
  name: "signin",

  data() {

    return {
      email : "" , 
      password : ""
    }
  },
  components: {
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  // methods:{
  //  goTodashboard(){
  //  this.$router.push('/dashboard'); 
  //     }
  // },
  methods:{
   Todashboard(){
   axios
   .post(`${APIs.API_URL}/admin/signIn`, {
    email: this.email,
    password:this.password
    })
    .then( (response) =>{
      if(response.data.error)
        return this.$toast.error(response.data.error)
      else {
          localStorage.setItem("user_id", response.data.user._id)
          localStorage.setItem("token", response.data.user.token)

          this.$router.push({ path: "/" });
      }

      // console.log(response.data)
      // this.$router.push({ path: "//dashboard-default" });
    })
    .catch(err => {
            console.log(err)
           if (err.response.data.error) {
              this.$toast.error(err.response.data.error);
           }
    });





    // .catch(function (error) {
    //     // console.log(error.response.data.error)
    //     if(error)
    //       // this.$toast.error(error.response.data.error);
    //         if (error.response.data.error) {
    //           alert(error.response.data.error)
    //        }
    // });
    }
  },
  
};
</script>

<style lang="scss" scoped>
  .bg-logo{
    background-color:#A68D5B ;
  }
</style>
